export const API_KEY_BODY = 'API_KEY_BODY';
export const API_KEY_HEADER = 'API_KEY_HEADER';
export const API_KEY_QUERY = 'API_KEY_QUERY';
export const BASIC = 'BASIC';
export const BEARER = 'BEARER';
export const OAUTH1 = 'OAUTH1';
export const OAUTH2 = 'OAUTH2';
export const OPENID = 'OPENID';
export const SAML = 'SAML';
export const AUTH_TYPE_CUSTOM = 'CUSTOM';

export const AUTH_TYPES = [
    AUTH_TYPE_CUSTOM,
    API_KEY_BODY,
    API_KEY_HEADER,
    API_KEY_QUERY,
    BASIC,
    BEARER,
    OAUTH1,
    OAUTH2,
    OPENID,
    SAML,
];

export const INTERNAL = 'internal';
export const SAAS = 'saas';

export const PROVIDER_TYPES = { INTERNAL, SAAS };

export const AUTH_TYPE_PATHS = {
    [AUTH_TYPE_CUSTOM]: 'dataMapping.authTypes.apiKey',
    [API_KEY_BODY]: 'dataMapping.authTypes.apiKey',
    [API_KEY_HEADER]: 'dataMapping.authTypes.apiKey',
    [API_KEY_QUERY]: 'dataMapping.authTypes.apiKey',
    [BASIC]: 'dataMapping.authTypes.apiKey',
    [BEARER]: 'dataMapping.authTypes.apiKey',
    [OAUTH1]: 'dataMapping.authTypes.oAuth',
    [OAUTH2]: 'dataMapping.authTypes.oAuth',
    [OPENID]: 'dataMapping.authTypes.openId',
    [SAML]: 'dataMapping.authTypes.saml',
};

export const ONE_CLICK_PATH = 'dataMapping.authTypes.oneClick';

export const STATUS_ERROR = 'ERROR';
export const STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const STATUS_SYNCED = 'SYNCED';
export const STATUS_QUEUED = 'QUEUED';
export const STATUS_WAITING_FOR_AUTH = 'WAITING_FOR_AUTH';

export const DATA_STORE_CONNECTION_STATUS = {
    [STATUS_ERROR]: 'dataStores.status.error',
    [STATUS_IN_PROGRESS]: 'dataStores.status.inProgress',
    [STATUS_SYNCED]: 'dataStores.status.synced',
    [STATUS_QUEUED]: 'dataStores.status.queued',
    [STATUS_WAITING_FOR_AUTH]: 'dataStores.status.waitingForAuth',
};

export const DATA_STORE_TYPES = {
    AUTOMATED: 'AUTOMATED',
    MANUAL: 'MANUAL',
};

export const TYPE_ON_PREM_SCHEMA = 'sqlSchema';
export const TYPE_ON_PREM_DATASET = 'sqlTable';
export const TYPE_ON_PREM_FIELD = 'sqlSchema';
export const TYPE_SAAS_SCHEMA = 'schema';
export const TYPE_SAAS_DATASET = 'object';
export const TYPE_SAAS_DATASET_ALT = 'table';
export const TYPE_SAAS_FIELD_SET = 'fieldSet';
export const TYPE_SAAS_FIELD = 'field';

export const COMPLETED = 'COMPLETED';
export const ERROR = 'ERROR';
export const EXPIRED = 'EXPIRED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const INITIALIZING = 'INITIALIZING';
export const NO_RESULTS = 'NO_RESULTS';
export const QUEUED = 'QUEUED';

export const CLASSIFICATION_UNCLASSIFIED = 'dataMapping.classificationTypes.none.name';

export const DATA_SEARCH_STATUS_KEYS = {
    COMPLETED,
    ERROR,
    EXPIRED,
    IN_PROGRESS,
    INITIALIZING,
    QUEUED,
};

export const DATA_DELETION_STATUS_KEYS = {
    COMPLETED,
    ERROR,
    EXPIRED,
    IN_PROGRESS,
    INITIALIZING,
    QUEUED,
};

export const RESOLVED_DATA_SEARCH_STATUS_KEYS = [COMPLETED, EXPIRED, NO_RESULTS, ERROR];

export const EVENTS = {
    ADD_DATA_STORE: 'AddDataStore',
    DELETE_DATA_STORE: 'DeleteDataStore',
    DELETE_DATA_STORE_FIELD: 'DeleteDataStoreField',
    NEW_DATA_STORE: 'NewDataStore',
    NEW_DATA_STORE_FIELD: 'NewDataStoreField',
    SELECT_AUTHENTICATION_METHOD: 'SelectAuthenticationMethod',
    SELECT_RESCAN: 'SelectRescan',
    ADD_PRODUCT_ASSOCIATION_CONFIRM: 'AddProductAssociationConfirm',
    ADD_PRODUCT_ASSOCIATION_CLOSE: 'AddProductAssociationClose',

    // TODO: Remove when ENABLE_PRIVACY_RISK is removed
    ADD_VENDOR_ASSOCIATION_CONFIRM: 'AddVendorAssociationConfirm',
    ADD_VENDOR_ASSOCIATION_CLOSE: 'AddVendorAssociationClose',
};

export const RECEIVER = 'RECEIVER';
export const SENDER = 'SENDER';

export const RELATIONSHIP_TYPES = {
    RECEIVER,
    SENDER,
};

export const DATA_STORE = 'DATA_STORE';
export const VENDOR = 'VENDOR';

export const RELATIONSHIP_TARGET_TYPES = {
    DATA_STORE,
    VENDOR,
};

export const DATA_DISCOVERY_OPERATION = 'SCHEMA';

export const FIELD_VISIBILITY_TYPES = {
    HIDDEN: 'HIDDEN',
    REDACT: 'REDACT',
    NONE: 'NONE',
};
